export default __webpack_public_path__ + "static/media/Conectividade (Real Size).ad29b762.svg";